import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CadastroDetalheComponent } from './cadastro-detalhe/cadastro-detalhe.component';
import { CadastroComponent } from './cadastro.component';
import { PesquisaDetalheComponent } from './pesquisa-detalhe/pesquisa-detalhe.component';
import { PesquisaInfoComponent } from './pesquisa-info/pesquisa-info.component';

const CadastroRoutes: Routes = [
    {
        path: 'cadastro',
        component: CadastroComponent,
        children: [
            {
                path: 'detalhe',
                component: CadastroDetalheComponent,
            },
            {
                path: 'pesquisa',
                component: PesquisaDetalheComponent,
                children: [
                    {
                        path: '',
                        component: PesquisaInfoComponent,
                    },
                ]
            },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(CadastroRoutes),
    ],
    exports: [
        RouterModule
    ],
})

export class CadastroRoutingModule { }
